export default "__VITE_ASSET__Dq$qYvJD__"